import { baseQuery } from '../baseQuery';

export type PutTaskPayload = {
  taskId: number;
  assignedToId?: number;
};

export const putTask = async ({ taskId, assignedToId }: PutTaskPayload) => {
  const data = await baseQuery(`task/${taskId}`, {
    type: 'PUT',
    body: {
      assigned_to: assignedToId,
    },
  });

  return data;
};
